import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, {
        width: "62",
        height: "62",
        viewBox: "0 0 62 62",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                filter: "url(#filter0_d_1_2711)",
                children: [
                    /*#__PURE__*/ _jsx("rect", {
                        x: "11",
                        y: "6",
                        width: "40",
                        height: "40",
                        rx: "12",
                        fill: "#194BFB",
                        shapeRendering: "crispEdges"
                    }),
                    /*#__PURE__*/ _jsxs("g", {
                        clipPath: "url(#clip0_1_2711)",
                        children: [
                            /*#__PURE__*/ _jsx("path", {
                                opacity: "0.48",
                                d: "M31.8333 34.3333C36.8959 34.3333 41 30.2293 41 25.1667C41 20.1041 36.8959 16 31.8333 16C26.7707 16 22.6667 20.1041 22.6667 25.1667C22.6667 26.2203 22.8444 27.2323 23.1715 28.1745C23.7641 27.8507 24.4439 27.6667 25.1667 27.6667C27.4679 27.6667 29.3333 29.5322 29.3333 31.8333C29.3333 32.5562 29.1493 33.2359 28.8255 33.8284C29.7677 34.1556 30.7798 34.3333 31.8333 34.3333Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ _jsx("path", {
                                d: "M32.5625 29.1479V30.0278H31.1042V29.1519C29.3987 28.8543 28.9167 27.5283 28.9167 26.7838H30.375C30.383 26.8998 30.4909 27.5948 31.8333 27.5948C32.8396 27.5948 33.2917 27.1204 33.2917 26.7838C33.2917 26.521 33.2917 25.9728 31.8333 25.9728C29.2958 25.9728 28.9167 24.4481 28.9167 23.5398C28.9167 22.4952 29.667 21.4442 31.1042 21.1757V20.3055H32.5625V21.2049C33.8268 21.5374 34.3125 22.7077 34.3125 23.5398H33.5833L32.8542 23.5544C32.8439 23.2462 32.6974 22.7288 31.8333 22.7288C30.8862 22.7288 30.375 23.1473 30.375 23.5398C30.375 23.8431 30.375 24.3508 31.8333 24.3508C34.3708 24.3508 34.75 25.8754 34.75 26.7838C34.75 27.8284 33.9997 28.8794 32.5625 29.1479Z",
                                fill: "white"
                            }),
                            /*#__PURE__*/ _jsx("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M25.1667 36C27.4678 36 29.3333 34.1345 29.3333 31.8334C29.3333 29.5322 27.4678 27.6667 25.1667 27.6667C22.8655 27.6667 21 29.5322 21 31.8334C21 34.1345 22.8655 36 25.1667 36ZM24.5417 29.9584C24.5417 29.6132 24.8215 29.3334 25.1667 29.3334C25.5118 29.3334 25.7917 29.6132 25.7917 29.9584V31.2084H27.0417C27.3868 31.2084 27.6667 31.4882 27.6667 31.8334C27.6667 32.1785 27.3868 32.4584 27.0417 32.4584H25.7917V33.7084C25.7917 34.0535 25.5118 34.3334 25.1667 34.3334C24.8215 34.3334 24.5417 34.0535 24.5417 33.7084V32.4584H23.2917C22.9465 32.4584 22.6667 32.1785 22.6667 31.8334C22.6667 31.4882 22.9465 31.2084 23.2917 31.2084H24.5417V29.9584Z",
                                fill: "white"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("filter", {
                        id: "filter0_d_1_2711",
                        x: "0",
                        y: "0",
                        width: "62",
                        height: "62",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ _jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ _jsx("feOffset", {
                                dy: "5"
                            }),
                            /*#__PURE__*/ _jsx("feGaussianBlur", {
                                stdDeviation: "5.5"
                            }),
                            /*#__PURE__*/ _jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ _jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.0980392 0 0 0 0 0.294118 0 0 0 0 0.984314 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1_2711"
                            }),
                            /*#__PURE__*/ _jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1_2711",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("clipPath", {
                        id: "clip0_1_2711",
                        children: /*#__PURE__*/ _jsx("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(21 16)"
                        })
                    })
                ]
            })
        ]
    });
};
export default Icon;
